import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect, } from "react";
const LanguageContext = createContext(undefined);
// `localStorage` может быть недоступен: в некоторых Android-WebView он
// возвращает null, в приватных режимах геттер бросает SecurityError.
// Без защиты любой такой кейс ронял первый рендер и приводил к пустому
// экрану (даже AppErrorBoundary с авто-восстановлением не помогал —
// `localStorage.clear()` тоже бросал). Всё хранилище тут опционально:
// если недоступно, просто работаем со значением по умолчанию.
function readStoredLanguage() {
    try {
        const saved = localStorage.getItem("language");
        if (saved === "ru" || saved === "en")
            return saved;
    }
    catch {
        /* localStorage unavailable */
    }
    return null;
}
function writeStoredLanguage(language) {
    try {
        localStorage.setItem("language", language);
    }
    catch {
        /* localStorage unavailable / quota — игнорируем */
    }
}
export const LanguageProvider = ({ children, }) => {
    const [language, setLanguage] = useState(() => readStoredLanguage() ?? "ru");
    useEffect(() => {
        writeStoredLanguage(language);
    }, [language]);
    return (_jsx(LanguageContext.Provider, { value: { language, setLanguage }, children: children }));
};
export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (context === undefined) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return context;
};
